/* eslint-disable max-lines-per-function */
/* eslint-disable camelcase */
import { useMutation, useQuery } from "@apollo/client";
import { navigate, RouteComponentProps } from "@reach/router";
import $ from "jquery";
import { get, omit } from "lodash";
import React from "react";
import { SelectInputProps } from "@material-ui/core/Select/SelectInput";
import { authorizeForRole, Roles } from "components/auth/authorize-for-role";
import logger from "services/logger";
import { parseDumbInterestForm } from "utils/interest";
import { useSnackbar } from "components/haven-design/snackbar";
import { LoadingSpinner } from "components/graphql-views";
import InterestUpdateView from "./interest-update";
import { QUERY_FORM_METADATA, UPDATE_INTEREST_DATA } from "./queries";

type Props = {
  interestId?: string;
  interestListId?: string;
}

const Container:React.FC<RouteComponentProps<Props>> = ({ interestId, interestListId }) => {
  const queryMetadataVariables = {
    interestListID: interestListId,
    interestID: interestId,
  };
  const { openSnackbar } = useSnackbar();
  const query = useQuery(QUERY_FORM_METADATA, { variables: queryMetadataVariables });
  const [update] = useMutation(UPDATE_INTEREST_DATA);

  if (query.loading) return <LoadingSpinner />;
  if (!query.data) return null;

  const { data: { interest } } = query;

  const handleChangeHousehold: SelectInputProps["onChange"] = (event: any) => {
    const variables = {
      interestID: interestId,
      data: { household_count: event.target.value },
    };
    update({ variables }).catch((err) => {
      logger.sendError(err);
      openSnackbar({ message: "Update failed. Please try again.", status: "error" });
    });
  };

  const updateFormData = (event:React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const formData = omit(parseDumbInterestForm($("form#interest-form")[0], interest), "temp-input");
    const variables = {
      interestID: interestId,
      data: formData,
    };

    update({ variables })
      .then(() => {
        openSnackbar({ message: "Update Success", status: "success" });
        window.scrollTo(0, 0);
        setTimeout(() => navigate("/dash/client/submissions"), 100);
      })
      .catch(() => {
        openSnackbar({ message: "There was an error while updating the application. Please try again.", status: "alert" });
      });
  };

  return (
    <InterestUpdateView
      listId={interestListId}
      listName={get(query, ["data", "applicationFormMetadata", "interestListName"], "")}
      interestId={interestId}
      handleSubmit={updateFormData}
      handleChangeHousehold={handleChangeHousehold}
      formData={get(query, ["data", "interest"]) || {}}
      validationSchema={get(query, ["data", "applicationFormMetadata", "schema"], [])}
    />
  );
};

export default authorizeForRole([Roles.Client], Container);
